export function getAlphaCharFromIndex(index: number) {
    let columnName = '';
    const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const alphabetSize = alphabets.length;
    const indexPlus = index + 1;
    const prefixWordIndex = indexPlus / alphabetSize;
    const suffixesWordIndex = indexPlus % alphabetSize;
    if (prefixWordIndex > 0 && alphabetSize !== indexPlus) {
        const temp = suffixesWordIndex === 0 ? alphabets[prefixWordIndex - 2] : alphabets[prefixWordIndex - 1];
        columnName += temp ? temp : '';
    }
    columnName += suffixesWordIndex === 0 ? 'Z' : alphabets[suffixesWordIndex - 1];

    return columnName;
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/string-helper.ts